import React from 'react';
import { Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader, Media } from 'reactstrap';
import { Link } from 'react-router-dom';

function About(props) {

    const RenderLeader = (props) => {
        const leader = props.leader
        return (
            <Media className = 'col-12 mb-4'>
                <Media left className ='col-2'>
                    <img src = {leader.image}/>
                </Media>
                <Media body>
                    <Media heading>{leader.name}</Media>
                    <p>{leader.designation}
                    </p>
                    <p>
                        {leader.description}
                    </p>
                </Media>
            </Media>
        )
    }

    const leaders = props.leaders.map((leader) => {
        return (
            <RenderLeader leader = {leader} key = {leader.id}/>
        );
    });

    return(

        <div className="container">
            <div className="row">
                <Breadcrumb>
                    <BreadcrumbItem><Link to="/home">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>About Us</BreadcrumbItem>
                </Breadcrumb>
                <div className="col-12">
                    <h3>About Us</h3>
                    <hr />
                </div>                
            </div>
            <div className="row row-content">
                <div className="col-12 col-md-6">
                    <h2>Our History</h2>
                    <p>Started in 2010, Fatima Bakery quickly established itself as a bakery icon par excellence in Tashkent, Uzbekistan. With its unique brand of world cakes that can be found nowhere else, it enjoys patronage from the A-list clientele in not only Tashkent, but whole in Central Asian Region.  Featuring four of the best three-star chefs in the world, you never know what will arrive on your plate the next time you visit us.</p>
                    <p>The Cakes Bakery traces its humble beginnings to <em>The Frying Pan</em>, a successful chain started by our CEO, Mr. Muzaffar, that featured for the first time the world's best bakery in a pan.</p>
                </div>
                <div className="col-12 col-md-5">
                    <Card>
                        <CardHeader className="bg-primary text-white">Facts At a Glance</CardHeader>
                        <CardBody>
                            <dl className="row p-1">
                                <dt className="col-6">Started</dt>
                                <dd className="col-6">07 Nov. 2011</dd>
                                <dt className="col-6">Major Stake Holder</dt>
                                <dd className="col-6">Fatima Trading & Foods Inc.</dd>
                                <dt className="col-6">Last Year's Turnover</dt>
                                <dd className="col-6">$1,500,375</dd>
                                <dt className="col-6">Employees</dt>
                                <dd className="col-6">30</dd>
                            </dl>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-12">
                    <Card>
                        <CardBody className="bg-faded">
                            <blockquote className="blockquote">
                                <p className="mb-0">"You can't buy happines but you can buy Cake and that's kind of the same thing.</p>
                                <footer className="blockquote-footer">Khalq Oghzaki Ijodi, 
                                <cite title="Source Title">
                                     Tradational Proverb, 2014</cite>
                                </footer>
                            </blockquote>
                        </CardBody>
                    </Card>
                </div>
            </div>
            <div className="row row-content">
                <div className="col-12">
                    <h2>Corporate Leadership</h2>
                </div>
                <div className="col-12">
                    <Media list className = 'pl-0 mt-2'>
                        {leaders}
                    </Media>
                </div>
            </div>
        </div>
    );
}

export default About;  